/* eslint-disable max-lines */
import { PhysiotherapyAssessmentConsultationQuestionConfig, PhysiotherapyAssessmentConsultationMode } from "../../../physiotherapy/models";

import * as questionIds from "./questionIds";

export const managerEmailAddressMasterConfig = {
    id: questionIds.ManagerEmailAddress,
    questionText: "Manager Email Address",
    canBeDisabled: false,
    consultationModes: [
        PhysiotherapyAssessmentConsultationMode.Face2Face,
        PhysiotherapyAssessmentConsultationMode.Telephone,
        PhysiotherapyAssessmentConsultationMode.Review
    ]
};
export const hrEmailAddressMasterConfig = {
    id: questionIds.HREmailAddress,
    questionText: "HR Email Address",
    canBeDisabled: false,
    consultationModes: [
        PhysiotherapyAssessmentConsultationMode.Face2Face,
        PhysiotherapyAssessmentConsultationMode.Telephone,
        PhysiotherapyAssessmentConsultationMode.Review
    ]
};
export const masterConfig: PhysiotherapyAssessmentConsultationQuestionConfig[] = [
    // Confirm Template to Use
    {
        id: questionIds.ConfirmTemplateToUse,
        questionText: "Confirm the clinical notes template you wish to use",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Subjective Assessment 1
    {
        id: questionIds.ClientsExpectations,
        questionText: "Clients Expectations",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.MainProblemOrProgressUpdate,
        questionText: "Main Problem or Progress Update",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.AdherenceToHomeExerciseAndAdvicePlan,
        questionText: "Adherence to Home Exercise and advice Plan",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.OnsetDate,
        questionText: "Onset Date",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.FirstEpisodeOfPain,
        questionText: "First Episode of Pain",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.ChronicProblem,
        questionText: "Chronic Problem",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.HistoryOfPresentComplaint,
        questionText: "History of Present Complaint",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.Injured,
        questionText: "Injured",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PainNRSAverage,
        questionText: "Pain NRS Average: 0 – No pain – 10 – Excruciating / worse pain ever",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.PainNRSWorse,
        questionText: "Pain NRS Worse: 0 – No pain – 10 – Excruciating / worse pain ever",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.PainNRSBest,
        questionText: "Pain NRS Best: 0 – No pain – 10 – Excruciating / worse pain ever",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.TwentyFourHourPattern,
        questionText: "24 Hour Pattern",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.AggravatingEasingFactors,
        questionText: "Aggravating / Easing Factors",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.Investigations,
        questionText: "Investigations",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PreviousTreatment,
        questionText: "Previous Treatment",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.DidThePreviousTreatmentHelp,
        questionText: "Did the Previous Treatment Help",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    {
        id: questionIds.DetailsOfPreviousTreatment,
        questionText: "Details of Previous Treatment",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face
        ]
    },
    // Subjective Assessment 2: CSSQ === Complete Cervical Spine Special Question
    {
        id: questionIds.CompleteCSSQs,
        questionText: "Complete Cervical Spine Special Questions",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQConstantHeadache,
        questionText: "1. Constant Headache",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQNausea,
        questionText: "2. Nausea",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQSensoryChanges,
        questionText: "3. Sensory changes: Pins and needles/numbness",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQDropAttacks,
        questionText: "4. Drop attacks",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQDizziness,
        questionText: "5. Dizziness",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQSwallowingDifficulties,
        questionText: "6. Swallowing difficulties",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQSpeechDifficulties,
        questionText: "7. Speech difficulties",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQVisionDifficulties,
        questionText: "8. Vision difficulties/double vision",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQAlteredGait,
        questionText: "9. Altered gait",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQConstantNightPain,
        questionText: "10. Constant Night pain",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQUnexplainedWeightLoss,
        questionText: "11. Unexplained weight loss",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CSSQPreviousHistoryOfCancer,
        questionText: "12. Previous history of Cancer",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    // Subjective Assessment 3: LSSQ === Lumbar Spine Special Question
    {
        id: questionIds.CompleteLSSQs,
        questionText: "Complete Lumbar Spine special questions",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQBowelOrBladderSymptoms,
        questionText: "1. Bowel or Bladder symptoms",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQSaddleAnaesthesia,
        questionText: "2. Saddle anaesthesia",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQBilateralLegPainPinsAndNeedles,
        questionText: "3. Bi-lateral leg pain/Pins and needles",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQAlteredGait,
        questionText: "4. Altered Gait",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQConstantNightPain,
        questionText: "5. Constant night pain",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQUnexplainedWeightLoss,
        questionText: "6. Unexplained weight loss",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.LSSQPreviousHistoryOfCancer,
        questionText: "7. Previous history of Cancer",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    // Subjective Assessment 4: PJSQ === Peripheral Joint Special Question
    {
        id: questionIds.CompletePJSQs,
        questionText: "Complete Peripheral Joint special questions",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PJSQSevereSwelling,
        questionText: "1. Severe swelling",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PJSQPoppingClicking,
        questionText: "2. Popping/Clicking",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PJSQGivingWayInstability,
        questionText: "3. Giving way/Instability",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PJSQLockingCatching,
        questionText: "4. Locking/Catching",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    // Subjective Assessment 5
    {
        id: questionIds.PastMedicalHistory,
        questionText: "Past Medical History",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.Medication,
        questionText: "Medication",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.FamilyHistory,
        questionText: "Family History",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.SmokingStatus,
        questionText: "Smoking Status",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CommentsOnSmokingStatus,
        questionText: "Comments on Smoking Status",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.AlcoholConsumptionInUnitsPerWeek,
        questionText: "Alcohol Consumption in Units per week",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.SocialHistoryHobbiesPhysicalActivity,
        questionText: "Social History including ADL’s/Hobbies and Physical Activity:",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.WorkDemands,
        questionText: "Work Demands",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.NumberOfDaysOffWorkDueToThisConditionInTheLast12Months,
        questionText: "No of days off work due to this condition in the last 12 months:",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.CurrentWorkStatus,
        questionText: "Current Work Status",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.ExpectedReturnToWorkDate,
        questionText: "Expected Return to Work date",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.MedicalClassification,
        questionText: "Medical Classification",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.SubCategory,
        questionText: "Sub Category",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Objective Assessment
    {
        id: questionIds.ObjectiveAssessmentFindings,
        questionText: "Objective Assessment Findings",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Assessment Summary 1
    {
        id: questionIds.ClinicalImpression,
        questionText: "Clinical Impression",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Assessment Summary 2: Psycho-social factors (HEADER)
    {
        id: questionIds.PainMeansHarm,
        questionText: "Pain means harm ",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.FearAvoidance,
        questionText: "Fear Avoidance",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.PassiveAttitude,
        questionText: "Passive Attitude",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.Catastrophising,
        questionText: "Catastrophising",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.WorkIsResponsible,
        questionText: "Work is responsible",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    {
        id: questionIds.MentalHealthIssues,
        questionText: "Mental Health Issues",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone
        ]
    },
    // Assessment Summary 3
    {
        id: questionIds.PsychoSocialFactorsBarriersToWork,
        questionText: "Psycho – social factors/barriers to work:",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Management & Outcome
    {
        id: questionIds.ManagementPlanAndTreatment,
        questionText: "Management Plan & Treatment",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.WorkRecommendationsAndReturnToWorkPlan,
        questionText: "Work Reccomendations and Return to Work Plan",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.SelfManagementAdviceAndExercisePlanProvided,
        questionText: "Self-management advice and exercise plan provided",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.Outcome,
        questionText: "Outcome",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    // Consent to release report
    {
        id: questionIds.ScopeOfReport,
        questionText: "Consent for release of Report",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.AlternativeConsentChoice,
        questionText: "Details of Alternative Consent choice",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    {
        id: questionIds.EmployeeEmailAddress,
        questionText: "Employee Email Address",
        canBeDisabled: false,
        consultationModes: [
            PhysiotherapyAssessmentConsultationMode.Face2Face,
            PhysiotherapyAssessmentConsultationMode.Telephone,
            PhysiotherapyAssessmentConsultationMode.Review
        ]
    },
    managerEmailAddressMasterConfig,
    hrEmailAddressMasterConfig
];
/* eslint-enable max-lines */
